import {memo} from 'react';

import styled from 'styled-components';

import {IMoneycardsRes, MoneyCard} from '~/shared/services/bffService/api/interfaces/responses';
import {headingXS, smallBold} from '~/shared/theme/typography';
import {getLocalizationService} from '~/shared/services/localisationService';

import ActionButton from './ActionButton';
import TenbisCardIcon from './assets/tenbisCardIcon.svg?react';

const Root = styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = styled.h2`
  ${headingXS}
  margin-bottom: 4px;
`;

const CaptionRoot = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`;

const Text = styled.span`
  ${smallBold}
`;

type TenbisCardCaptionProps = {
  fourDigits: string;
};

const TenbisCardCaption = ({fourDigits}: TenbisCardCaptionProps) => {
  const {t} = getLocalizationService();
  return (
    <CaptionRoot>
      <TenbisCardIcon />
      <Text>{t('tenbis_card_xxx', {fourDigits})}</Text>
    </CaptionRoot>
  );
};

type TenbisCardsListProps = {
  moneycards: IMoneycardsRes;
  onMoneycardClick?: (moneycard: MoneyCard) => void;
};

const TenbisCardsList = ({moneycards, onMoneycardClick}: TenbisCardsListProps) => {
  const {t} = getLocalizationService();
  return (
    <Root>
      <Title>{t('your_10bis_cards')}</Title>
      {moneycards && moneycards.map((moneycard, index) => (
        <ActionButton
          key={moneycard.id}
          caption={<TenbisCardCaption fourDigits={moneycard.cardLastDigits} />}
          withBorderTop={index > 0}
          onClick={() => onMoneycardClick?.(moneycard)}
        />
      ))}
    </Root>
  );
};

export default memo(TenbisCardsList);
